<div class="form-group-context">
  <label class="d-flex form-group-context-label">
    <span class="form-group-context-item d-flex align-items-center">
      {{ label }}
    </span>
    <span class="form-group-context-item" #contentEl>
      <ng-content></ng-content>
    </span>
  </label>
</div>
